<template>
  <div>
    <div class="content-header">
      <div class="left">应用中心</div>
      <div class="right"></div>
      <div class="bottom"></div>
    </div>
    <div class="pageTitle">单项增值功能</div>
    <div class="itembox">
      <!--  @click="selectType(0)" -->
      <div
        class="item"
        @mouseover="itemStyle1 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle1 = ''"
        :style="itemStyle1"
      >
        <img class="icon" src="../../../assets/images/application1.png" />
        <div class="r_box">
          <div class="titbox">
            <p class="tit">在线客服（高级版）</p>
            <p class="money">即将推出</p>
          </div>
          <div class="des">在线与会员进行沟通，可指定多个员工成为客服。</div>
        </div>
      </div>
      <div
        class="item"
        @click="selectType(1)"
        @mouseover="itemStyle2 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle2 = ''"
        :style="itemStyle2"
      >
        <img class="icon" src="../../../assets/images/application2.png" />
        <div class="r_box">
          <div class="titbox">
            <p class="tit">商品视频功能</p>
            <p class="money">
              {{ shop_agent.goods_video.status ? "已开通" : "未开通" }}
            </p>
          </div>
          <div class="des">
            可为商品添加宣传短视频，让消费者更直观的了解商品。
          </div>
        </div>
      </div>
    </div>
    <div class="pageTitle">营销推广</div>
    <div class="itembox">
        <!-- @click="selectType(2)" -->
      <div
        class="item"
        @mouseover="itemStyle3 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle3 = ''"
        :style="itemStyle3"
      >
        <img class="icon" src="../../../assets/images/application3.png" />
        <div class="r_box">
          <div class="titbox">
            <p class="tit">粉丝推广(共享佣金)</p>
            <p class="money">即将推出</p>
            <!-- <p class="money">
              {{ shop_agent.goods_video.status ? "已开通" : "未开通" }}
            </p> -->
          </div>
          <div class="des">
            设立成交佣金，关联购买，提高购买转化率，提升销售笔数和商品曝光率 。
          </div>
        </div>
      </div>
      <div
        class="item"
        @click="selectType(3)"
        @mouseover="itemStyle4 = 'border: 1px solid #D40000;'"
        @mouseout="itemStyle4 = ''"
        :style="itemStyle4"
      >
        <img class="icon" src="../../../assets/images/application4.png" />
        <div class="r_box">
          <div class="titbox">
            <p class="tit">短信套餐包</p>
            <p class="money">剩余{{ shop_agent.sms_num }}条</p>
          </div>
          <div class="des">支持国内快速发送验证码、短信通知和推广短信。</div>
        </div>
      </div>
    </div>

    <Drawer
      :title="modal.title"
      :closable="false"
      v-model="modal.status"
      width="1000"
    >
      <div class="app_drawer_content">
        <div>
          <div class="pageTitle">选择购买时长
             <span class="tips">(当前功能到期时间：{{ $moment(shop_agent.goods_video.operate_time, "YYYY-MM-DD") }}，可叠加购买)</span>
          </div>
          <RadioGroup
            v-model="modal.data.month"
            style="margin-top: 10px; padding-left: 10px"
            @on-change="changeMonth"
          >
            <Radio :label="12" style="margin-right: 122px"> 12月</Radio>
            <Radio :label="24" style="margin-right: 110px"> 24月(8.5折优惠)</Radio>
            <Radio :label="36"> 36月(7折优惠)</Radio>
          </RadioGroup>
          <div
            style="
              border-bottom: 1px solid #ddd;
              padding-bottom: 30px;
              padding-top: 20px;
            "
          >
            <div class="pageTitle">支付方式</div>
            <RadioGroup
              v-model="modal.data.pay_type"
              style="margin-top: 10px; padding-left: 10px"
              @on-change="changeMonth"
            >
              <Radio :label="0" style="margin-right: 60px">
                <img class="pay_icon" src="../../../assets/images/ic_pay2.png"
              /></Radio>
              <Radio :label="3">
                <img class="pay_icon" src="../../../assets/images/ic_pay1.png"
              /></Radio>
            </RadioGroup>

            <div class="bankPayBox" v-if="modal.data.pay_type === 3">
              <!-- modal.data.pay_type -->
              <div class="item">
                <p class="tit">开户行：</p>
                <p class="txt">招商银行重庆高新区支行</p>
              </div>
              <div class="item">
                <p class="tit">对公账号：</p>
                <p class="txt">1239 0814 9310 902</p>
              </div>
              <div class="item">
                <p class="tit">开户名：</p>
                <p class="txt">云知印（重庆）信息技术有限公司</p>
              </div>
              <div class="item">
                <p class="tit">转账凭证：</p>
                <div class="voucher_uploadBox">
                  <div
                    class="imgBox"
                    v-for="(item, index) in modal.data.pay_params.img"
                    :key="index"
                  >
                    <img :src="item" alt="" srcset="" class="img" />
                    <Icon
                      type="md-close"
                      class="close"
                      @click="deleteImage(index)"
                    />
                  </div>
                  <div
                    class="upload"
                    v-if="modal.data.pay_params.img.length < 3"
                  >
                    <p class="t">
                      点击上传
                      <span style="color: #555; font-size: 10px">最多3张</span>
                    </p>
                    <input type="file" class="upBtn" @change="uploadImage" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pageTitle">功能介绍</div>
          <div class="function_content">
            <span v-if="modal.title=='已选：商品视频功能'">可为商品添加宣传短视频，让消费者更直观的了解商品。</span>
            <span v-else>即将推出</span>
            <!-- <img src="../../../assets/images/login_new_bg.png">
          <img src="../../../assets/images/login_new_bg.png"> -->
          </div>
        </div>
        <div class="moneyBox">
          <div class="l">
            总计：<span style="font-size: 20px; color: #E8244A"
              ><span style="font-size: 14px">￥</span
              >{{ modal.data.money }}</span
            >
              <span v-if="modal.data.month >= 24"
            >（省{{ modal.data.coupon }}元）</span
           >
          </div>
          <div class="payBtn" @click="submit">立即支付</div>
        </div>
      </div>
    </Drawer>

    <Modal
      v-model="payModalStatus"
      title="微信扫码支付"
      width="600"
      mask
      cancel-text=" "
      :footer-hide="true"
      @on-ok="handlePayOver"
    >
      <div class="qrcodeBox" ref="qrcodeBox"></div>
      <p style="text-align: center; line-height: 35px; margin-top: 20px">
        支付完成后请手动关闭此弹窗
      </p>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { uploadOSS } from "@/libs/util";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      modal: {
        status: false,
        title: "",
        data: {
          code: "",
          month: 12,
          pay_type: 0,
          pay_params: {
            img: [],
          },
          money: "",
        },
      },
      itemStyle1: "",
      itemStyle2: "",
      itemStyle3: "",
      itemStyle4: "",
      payModalStatus: false,
      base_money:0,
      isOpenTask:false
    };
  },
  mounted() {
    this.getShopInfo();
  },
  methods: {
    ...mapActions([
      "GetApplicationPrice",
      "CreateApplicationOrder",
      "GetShopInfo",
    ]),
    getShopInfo(){
      this.GetShopInfo().then((res) => {
        let data = res.data;
        let infoStatus=false,shopStatus=false;
        if (
          data.contacts &&
          data.contacts_tel &&
          data.province &&
          data.city &&
          data.area &&
          data.email &&
          data.service_tel &&
          data.introduce
        ) {
          infoStatus = true;
        }
        shopStatus = this.shop_agent.check_status==1;
        if(infoStatus&&shopStatus){
          this.isOpenTask = true;
        }
      });
    },
    selectType(e) {
      if (e === 3) {
        this.$router.push("/application/message");
        return false;
      }
      this.modal.data = {
        code: "",
        month: 12,
        pay_type: 0,
        pay_params: {
          img: [],
        },
        money: "",
      };
      let arr = [
        {
          code: "service",
          title: "已选：在线客服（高级版）",
        },
        {
          code: "goods_video",
          title: "已选：商品视频功能",
        },
        {
          code: "share",
          title: "已选：粉丝推广（共享佣金）",
        },
      ];
      this.modal.data.code = arr[e].code;
      this.modal.title = arr[e].title;
      this.modal.status = true;
      this.changeMonth(12);
    },
    changeMonth(e) {
      this.GetApplicationPrice(this.modal.data).then((res) => {
        this.modal.data.money = res.data.price.toFixed(2);
         if(e===12){
            this.base_money = res.data.price;
         }
         if (e === 24) {
          this.modal.data.coupon = (
            this.base_money * 2 -
            this.base_money * 2 * 0.85
          ).toFixed(2);
        }
        if (e === 36) {
          this.modal.data.coupon = (
            this.base_money * 3 -
            this.base_money * 3 * 0.7
          ).toFixed(2);
        }
      });
    },
    deleteImage(index) {
      this.modal.data.pay_params.img.splice(index, 1);
    },
    uploadImage(e) {
      console.log("e", e);
      uploadOSS(`shop/${this.current_user.shop_id}/`, e.target.files[0]).then(
        (oss) => {
          console.log("oss", oss);
          this.modal.data.pay_params.img.push(oss.url);
        }
      );
    },
    submit() {
      if(!this.isOpenTask){//沒有主体认证的提醒
          this.$Modal.confirm({
              title:'重要提醒',    
              content:'为了店铺安全和保障消费者权益，请完善店铺开张任务后使用此功能！',
              width:560,
              okText:'立即完善',
              onCancel:()=>{
              },
              onOk:()=>{
                this.$router.push({ name: "open_task" });
              }
          })
          return;
      }
      let data = JSON.parse(JSON.stringify(this.modal.data));
      if (data.pay_type === 3 && !data.pay_params.img.length) {
        this.$Message.error("请上传支付凭证");
        return false;
      }
      this.CreateApplicationOrder(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
        if (data.pay_type === 0) {
          this.payModalStatus = true;
          //微信支付 弹出二维码框
          this.$nextTick(() => {
            this.$refs.qrcodeBox.innerHTML = "";
            const qrcode = new QRCode(this.$refs.qrcodeBox, {
              text: res.data.url,
              width: 200,
              height: 200,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H,
            });
          });
        } else {
          this.modal.status = false;
        }
      });
    },
    handlePayOver() {
      console.log("sdasd");

      this.modal.status = false;
      this.payModalStatus = false;
    },
  },
  computed: mapGetters({
    shop_agent: "shop_agent",
    current_user: "current_user",
  }),
  watch: {},
};
</script>
<style lang='less' scoped>
@import "./index.less";
</style>
